<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-row>
    <v-col cols="12" sm="12">
      <v-row align="center">
        <v-col></v-col>
        <v-col cols="2">
          <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
          ></v-text-field>
        </v-col>
        <v-col class="text-right" cols="2">
          <v-btn @click="$router.push({ name: 'promocode-create' })">Создать промокод</v-btn>
        </v-col>
      </v-row>
      <v-data-table
          no-data-text="Нет кодов"
          no-results-text="По заданному запросу ничего не найдено"
          :headers="headers"
          :items="promocodes"
          :header-props="{sortIcon: 'icon-custom-arrow'}"
          v-model="selected"
          :search="search"
          :options.sync="options"
          :footer-props="footerProps"
          :server-items-length="totalProducts"
          :loading="loading"
          loading-text="Загрузка кодов... Подождите пожалуйста"
      >
        <template v-slot:item.order_count="{ item }">
          <a :href="'/promocode/orders/' + item.id">{{ item.order_count }}</a>
        </template>
        <template v-slot:item.date_to="{ item }">
          {{ fixDateTo(item.date_to) }}
        </template>

        <template v-slot:item.type="{ item }">
          {{ item.type ? types[item.type] : (item.is_multiple ? 'Многоразовый(старый)' : 'Одноразовый(старый)') }}
        </template>

        <template v-slot:item.code="{ item }">
          <template v-if="item.code">
            {{ item.code }}
          </template>
          <template v-else-if="item.last_code">
            {{ item.last_code.code }}
          </template>
        </template>
        <template v-slot:item.products="{ item }">
          <span v-for="product in item.products">{{ product.name }}{{
              product == item.products[item.products.length - 1] ? '' : ', '
            }} </span>
        </template>
        <template v-slot:item.actions="{ item }">
          <div class="text-right">

            <v-menu offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                    small
                    class="mr-2"
                    v-bind="attrs"
                    v-on="on"
                >
                  mdi-dots-vertical
                </v-icon>
              </template>
              <v-list>
                <v-list-item @click="$router.push({ name: 'promocode-edit', params: { id: item.id } })">
                  <v-list-item-title>Редактировать</v-list-item-title>
                </v-list-item>
                <v-list-item @click="submitDialog = true; submitItem = item">
                  <v-list-item-title>Удалить</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </div>
        </template>
      </v-data-table>
      <!--</v-card>-->
    </v-col>
    <v-dialog
        v-model="submitDialog"
        max-width="444"
    >
      <v-card>
        <v-card-title>
          Подтвердить действие
        </v-card-title>

        <v-card-actions>


          <v-btn
              v-if="submitItem == null"
              @click="submitDelete(submitItem); submitDialog = false">
            Да
          </v-btn>
          <v-btn
              v-else
              @click="submitDelete(submitItem); submitDialog = false">
            Да
          </v-btn>
          <v-btn
              outlined
              @click="submitDialog = false"
          >
            Нет
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
// @ is an alias to /src

import PromocodeService from '../../api/PromocodeService'

export default {
  name: 'PromocodeIndex',
  components: {},
  data: () => ({
    overlay: false,
    search: '',
    loadingModal: false,
    loading: true,
    tab: null,
    dialog: false,
    selected: [],
    promocodes: [],
    submitDialog: false,
    submitItem: null,
    branches: [],
    options: {},
    types: ['', 'Одноразовый', 'Многоразовый', 'Многоразово-одноразовый', 'Ручная выдача'],
    promocode: {
      id: null,
      name: '',
      name_ua: '',
    },
    footerProps: {
      itemsPerPageText: 'Промокодов на страницу',
      pageText: '{0}-{1} из {2}',
      itemsPerPageAllText: 'Все',
      itemsPerPageOptions: [15, 60, -1]
    },
    totalProducts: 0,
    headers: [
      {
        text: 'Название',
        value: 'name',
        sortable: false
      },
      {
        text: 'Блюдо',
        value: 'products',
        sortable: false
      },
      {
        text: 'Бонусы',
        value: 'bonus',
        sortable: false
      },
      {
        text: 'Срок действия',
        value: 'date_to',
        sortable: false
      },
      {
        text: 'Количество заказов',
        value: 'order_count',
        sortable: false
      },
      {
        text: 'Сумма заказов',
        value: 'order_amount',
        sortable: false
      },
      {
        text: 'Начинает действовать',
        value: 'date_from',
        sortable: false
      },
      {
        text: 'Код',
        value: 'code',
        sortable: false
      },
      {
        text: 'Тип',
        value: 'type',
        sortable: false
      },
      {
        text: 'Кол-во использований',
        value: 'count_use',
        sortable: false
      },
      {text: 'Действия', value: 'actions', sortable: false, width: "5%"},
    ],
  }),
  mounted() {
  },
  watch: {
    options: {
      handler() {
        this.getDataFromApi()
      },
      deep: true,
    },
    search: function (value) {

      this.loading = true
      this.selected = [];
      PromocodeService.list({
        page: this.options.page,
        perPage: this.options.itemsPerPage,
        search: value,
        sortBy: this.options.sortBy.length > 0 ? this.options.sortBy[0] : '',
        sortDesc: this.options.sortBy.length > 0 ? this.options.sortDesc[0] : '',
      })
          .then(response => {
            this.promocodes = response.data.data
            this.totalProducts = response.data.total
            this.loading = false
          })
    }
  },
  methods: {
    submitDelete(item = null) {
      if (item) {
        this.removePromocode(item)
      } else {
      }
    },
    fixDateTo(dateTo) {
      if (!dateTo) {
        return '-'
      }
      const dt = new Date(dateTo);
      dt.setHours(dt.getHours() - 24);
      return dt.toISOString().slice(0, 10);
    },
    removePromocode(item) {
      this.loading = true
      PromocodeService.remove(item.id).then(response => {
        this.getDataFromApi()
      })
    },
    getDataFromApi() {
      this.loading = true
      this.selected = [];
      PromocodeService.list({
        page: this.options.page,
        perPage: this.options.itemsPerPage,
        search: this.search,
        sortBy: this.options.sortBy.length > 0 ? this.options.sortBy[0] : '',
        sortDesc: this.options.sortBy.length > 0 ? this.options.sortDesc[0] : '',
      })
          .then(response => {
            this.promocodes = response.data.data
            this.totalProducts = response.data.total
            this.loading = false
          })
    },
  }
}
</script>

<style>
.changed-row {
  background-color: #FFEEEC;
}
</style>

<style lang="scss" scoped>
.v-btn--fab.v-size--x-small {
  width: 20px;
  height: 20px;

  .mdi::before {
    font-size: 12px;
  }
}

span.v-btn {
  border-color: currentColor !important;
}

.filter-popup {
  position: absolute;
  width: 250px;
  z-index: 5;

  &:hover {
    cursor: auto;
  }


  &.v-card--link:focus::before {
    opacity: 0;
  }
}
</style>
